import { useDrag, useDrop } from "react-dnd";

import dragIcon from "assets/icons/drag-icon.svg";
import burgerIcon from "assets/icons/burger-icon.svg";
import editIcon from "../../../../assets/icons/edit-icon.svg";
import viewIcon from "../../../../assets/icons/eye.svg";
import { GameCenterFormTypes, ModalTypes } from "../../../../configs/types";
import { openModal } from "../../../../store/modals/slice";
import { useAppDispatch } from "../../../../store";
import { useNavigate } from "react-router-dom";
import { capitalize } from "helpers/capitalize";
import SwitchBtn from "components/buttons/SwitchBtn";
import ImageWithFallback from "helpers/ImageWithFallback";
import { t } from "i18next";
import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import cn from "clsx";

const ALLOWED_LIST_EDIT = ["banner", "tag", "collection"];

const MainPageSortItem = ({
  item,
  index,
  moveItem,
  isSelected,
  handleClick,
  isBurger,
  isMainWidgetPage,
  isSignUpForm,
  onToggleRequired,
  bonusOptions,
  onSelectBonus,
  customContent,
  hideImage,
  disableEdit,
  isDraggable,
  readOnly,
}: {
  item: any;
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  isSelected: boolean;
  handleClick: (item: any) => void;
  isBurger?: boolean;
  isMainWidgetPage?: boolean;
  isSignUpForm?: boolean;
  onToggleRequired?: () => void;
  bonusOptions?: { value: number; label: string; img: string }[];
  readOnlyBonus?: boolean;
  onSelectBonus?: (val: number, index: number) => void;
  customContent?: React.ReactNode;
  hideImage?: boolean;
  disableEdit?: boolean;
  isDraggable?: boolean;
  readOnly?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isDecorativeGear = item.img === burgerIcon;

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "page_item",
      item: { index },
      // canDrag: isDraggable,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [index],
  );

  const [, drop] = useDrop(
    () => ({
      accept: "page_item",
      drop: (draggedItem: { index: number }) => {
        if (!isDraggable) return;

        if (draggedItem.index !== index) {
          moveItem(draggedItem.index, index);
          draggedItem.index = index;
        }
      },
    }),
    [index, isDraggable, moveItem],
  );

  const handleOpenEditModal = (item: any) => {
    const type = item?.type;
    let url =
      type === "banner"
        ? `${location.pathname}?activeModal=${ModalTypes.banners}&entityId=${item?.value}`
        : // @ts-ignore
          `${location.pathname}?activeModal=${ModalTypes.gameCenter}&gModalType=${GameCenterFormTypes[type]}&entityId=${item?.value}`;

    navigate(url);
    dispatch(
      openModal({
        activeModal:
          type === "banner" ? ModalTypes.banners : ModalTypes.editGame,
      }),
    );
  };

  return (
    <div
      onClick={handleClick}
      ref={(node) => drag(drop(node))}
      className={cn(
        "item",
        isSelected && "selected",
        isBurger && "burger",
        isDecorativeGear && "without-decorative-gear",
        !isDraggable && "not-draggable",
        isDragging && !isDraggable && "dragging-not-allowed",
      )}
      style={{ opacity: isDragging ? 0.5 : 1 }}
    >
      <div className="row">
        <img className="drag-icon" src={dragIcon} alt="" />
        {!hideImage && !isDecorativeGear && (
          <ImageWithFallback className="item-img" src={item.img} />
        )}
        {/* <span>{item.showType ? item.type : item.label}</span> */}
        <span className="item-title" title={capitalize(item.label)}>
          {capitalize(item.label)}
        </span>
      </div>

      <div className="row">
        <>
          {isSignUpForm && item.value === "bonus" && (
            <div className="row">
              <div
                className="bonus-dropdown-wrapper"
                onClick={(e) => e.stopPropagation()}
              >
                <DefaultDropdown
                  value={item.instanceId ?? undefined}
                  placeholder={t("Select")}
                  options={bonusOptions ?? []}
                  onSelect={(val) => {
                    onSelectBonus?.(Number(val), index);
                  }}
                  disabled={readOnly}
                  isEllipsis
                />
              </div>
            </div>
          )}
          {customContent}
        </>

        {isMainWidgetPage &&
          !disableEdit &&
          ALLOWED_LIST_EDIT.includes(item.type) && (
            <div className="drag-edit-wrap">
              <div
                className="drag-edit-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenEditModal(item);
                }}
              >
                {readOnly ? (
                  <img src={viewIcon} alt="" />
                ) : (
                  <img src={editIcon} alt="" />
                )}
              </div>
            </div>
          )}
        {item.showType && (
          <div className={`type-label ${item.type}`}>
            {item.type === "multiScope" ? t("multi") : t(item.type)}
          </div>
        )}
        {onToggleRequired && (
          <div
            className="required-wrapper"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <SwitchBtn
              isActive={item.required}
              handleClick={onToggleRequired}
              activeTxt={t("Required")}
              notActiveTxt={t("Optional")}
              disabled={readOnly}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MainPageSortItem;
